import React, {useRef} from "react";
import {css} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {calculateRemSize as crs, p} from "@pg-design/helpers-css-strings";

import {OfferRankingCreationSteps} from "../components/offer_ranking/OfferRankingCreationSteps";
import {OfferRankingExpert} from "../components/OfferRankingExpert";
import {RankingHeader} from "../components/ranking_header/RankingHeader";
import {RankingCitiesTiles} from "../components/RankingCitiesTiles";
import {RankingPartners} from "../components/RankingPartners";

export const RankingMainView = () => {
    const processRef = useRef<HTMLDivElement>(null);

    const scrollToRankingCreationSteps = () => {
        processRef.current && processRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
    };

    return (
        <article>
            <RankingHeader onScrollToRankingCreationSteps={scrollToRankingCreationSteps} />
            <RankingCitiesTiles />
            <div css={aboutRanking}>
                <WideContent>
                    <OfferRankingCreationSteps scrollRefElem={processRef} />
                </WideContent>
                <OfferRankingExpert />
            </div>
            <div css={partnersWrap}>
                <RankingPartners />
            </div>
        </article>
    );
};

// Styles
const aboutRanking = css`
    ${p(9, 0, 0, 0)};
    display: flex;
    flex-direction: column;
    gap: ${crs(5)};
    align-items: center;
`;

const partnersWrap = css`
    ${p(7, 0, 0, 0)};
    background: white;
`;
import React, {useRef} from "react";
import {css} from "@emotion/react";

import {WideContent} from "@pg-design/grid-module";
import {calculateRemSize as crs, p} from "@pg-design/helpers-css-strings";

import {OfferRankingCreationSteps} from "../components/offer_ranking/OfferRankingCreationSteps";
import {OfferRankingExpert} from "../components/OfferRankingExpert";
import {RankingHeader} from "../components/ranking_header/RankingHeader";
import {RankingCitiesTiles} from "../components/RankingCitiesTiles";
import {RankingPartners} from "../components/RankingPartners";

export const RankingMainView = () => {
    const processRef = useRef<HTMLDivElement>(null);

    const scrollToRankingCreationSteps = () => {
        processRef.current && processRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
    };

    return (
        <article>
            <RankingHeader onScrollToRankingCreationSteps={scrollToRankingCreationSteps} />
            <RankingCitiesTiles />
            <div css={aboutRanking}>
                <WideContent>
                    <OfferRankingCreationSteps scrollRefElem={processRef} />
                </WideContent>
                <OfferRankingExpert />
            </div>
            <div css={partnersWrap}>
                <RankingPartners />
            </div>
        </article>
    );
};

// Styles
const aboutRanking = css`
    ${p(9, 0, 0, 0)};
    display: flex;
    flex-direction: column;
    gap: ${crs(5)};
    align-items: center;
`;

const partnersWrap = css`
    ${p(7, 0, 0, 0)};
    background: white;
`;
